import { HOSPITOL_API_BASE_URL } from "@/core/config";
import { loadStoredSession, getStoredMeta } from "@itaas/core/auth/auth.storage";
import { setTenantEdition } from "@/core/navigation/edition-menu-mask";

/** Load tenant edition/profile from API and apply menu/route mask (WP-H5). */
export async function syncTenantEditionProfile(): Promise<string | null> {
  try {
    const slug = loadStoredSession()?.tenant?.slug ?? "demo-hospitol";
    const headers: Record<string, string> = {
      Accept: "application/json",
      "X-Tenant-Slug": slug,
    };
    const { accessToken } = getStoredMeta();
    if (accessToken) headers.Authorization = `Bearer ${accessToken}`;

    const res = await fetch(`${HOSPITOL_API_BASE_URL}/tenant/edition-profile`, {
      headers,
    });
    if (!res.ok) return null;
    const data = (await res.json()) as { edition?: string };
    if (data.edition) {
      setTenantEdition(data.edition);
      return data.edition;
    }
    return null;
  } catch {
    return null;
  }
}

export async function recordAuthAuditEvent(
  action: "login" | "logout" | "session_resume",
): Promise<void> {
  try {
    const slug = loadStoredSession()?.tenant?.slug ?? "demo-hospitol";
    const headers: Record<string, string> = {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-Tenant-Slug": slug,
    };
    const { accessToken } = getStoredMeta();
    if (accessToken) headers.Authorization = `Bearer ${accessToken}`;
    await fetch(`${HOSPITOL_API_BASE_URL}/audit/auth-events`, {
      method: "POST",
      headers,
      body: JSON.stringify({ action, tenantSlug: slug }),
    });
  } catch {
    /* non-blocking */
  }
}
